/* eslint-disable max-len */
/* eslint-disable no-console */

import { warningMarkerData } from '../../shared/constantVariable';

function jsontocsvConvertion(props, dssro_data) {
  const {
    stream_output,
    coverpage_dict,
    feed_product_waste_summary,
    system_units,
    cf_summary,
    pump_summary,
    argo_summary,
    erd_summary,
    mixer_summary,
    stripper_summary,
    clro_elem_summary,
    clro_overview,
    chem_dose_summary,
    edi_summary,
    ro_elem_summary,
    ro_summary,
    ro_hp,
    errors,
    pdfoption,
    ediOutputData
  } = props;
  const { perm_loop_data, conc_loop_data } = Object.keys(dssro_data).length > 0 ? dssro_data[0].output_user : { perm_loop_data: {}, conc_loop_data: {} };
  const newData = pdfoption.reduce((acc, obj) => {
    acc[obj.label] = !!((obj.disabled && obj.checked)); // assign the value to the label in the accumulator
    return acc;
  }, {});
  const addUnitsInMixerSplitter = () => {
    const obj = {};
    Object.keys(mixer_summary[mixer_summary['Mixer-Splitter Unit ID'][0]]).map((ele) => {
      let str = '-';
      if (ele === 'Split Ratios') {
        str = '(user input)';
      } else if (ele === 'Mix Ratios') {
        str = '(calculated)';
      }
      obj[ele] = str;
      return ele;
    });
    mixer_summary.units = obj;
  };

  // using this function we are handling values  ----> Kranthi
  const appendNumberText = (value, floatdecimal) => {
    floatdecimal = floatdecimal || 2;
    if (value === undefined) {
      return '-';
    }
    if (Number.isNaN(Number(value))) { // checking values is number or not ----> Kranthi
      if (value.includes(',')) {
        return value.replaceAll(',', ' ');
      }
      const split_Val = value.split(' '); // spliting all the value with space ----> Kranthi
      if (split_Val.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = !Number.isNaN(Number(split_Val[0])) ? Number(split_Val[0]).toFixed(floatdecimal) : split_Val[0];
        const text_val = split_Val[1];
        return `${num_val} ${text_val}`; // combing text and value ----> Kranthi
      }
      const split_perval = value.split('%'); // spliting all the value with % ----> Kranthi
      if (split_perval.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = !Number.isNaN(Number(split_perval[0])) ? Number(split_perval[0]).toFixed(floatdecimal) : split_perval[0];
        return `${num_val}`; // showing text ----> Kranthi
      }
      return value;
    }
    return Number(value).toFixed(floatdecimal);
  };
  // using this function we are handling values  ----> Kranthi
  const appendNumberText2 = (value) => {
    if (value === undefined) {
      return '-';
    }
    if (Number.isNaN(Number(value))) { // checking values is number or not ----> Kranthi
      if (value.includes(',')) {
        return value.replaceAll(',', ' ');
      }
      const split_Val = value.split(' '); // spliting all the value with space ----> Kranthi
      if (split_Val.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const numMatch = value.match(/[0-9]*\.?[0-9]+/g);  // extracts number from string
        if (numMatch) {
          const num = numMatch[0];
          if (!Number.isNaN(num)) {
            const formattedNum = Number(num).toFixed(2);  // formats it to 2 dp
            return value.replace(num, formattedNum);  // substitutes new formatted number into original string
          }
        }
      }
      const split_perval = value.split('%'); // spliting all the value with % ----> Kranthi
      if (split_perval.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = !Number.isNaN(Number(split_perval[0])) ? Number(split_perval[0]).toFixed(2) : split_perval[0];
        return `${num_val}`; // showing text ----> Kranthi
      }
      return value;
    }
    return Number(value).toFixed(2);
  };
  const setCLRO_Stream_data = (tableValue, str, arr) => {
    arr.push(
      str === 'stream' ? [] : [str],
      ['Category', 'Parameter', '', ...Object.keys(tableValue)],
      str === 'stream' ? [
        'Stream Name',
        '',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].label)
      ] : [],
      [
        'Ion Concentration',
        'Ca++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Ca++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Mg++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Mg++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Na+',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Na+'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'K+',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['K+'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'NH4+',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['NH4+'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Ba++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Ba++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Sr++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Sr++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Fe++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Fe++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Mn++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Mn++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'SO4--',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['SO4--'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Cl-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Cl-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'F-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['F-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'NO3-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['NO3-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'Br-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Br-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'PO4---',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['PO4---'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'B-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['B-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'SiO2',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict.SiO2.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'H2S',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict.H2S.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'HCO3-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['HCO3-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'CO2',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict.CO2.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'CO3--',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['CO3--'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Ion Concentration',
        'TDS',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].prop_dict.tds.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        'Stream Property',
        'Flow',
        system_units['Volume Flow'],
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.flow.toFixed(2))
      ],
      [
        'Stream Property',
        'Pressure',
        system_units.Pressure,
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.press.toFixed(2))
      ],
      [
        'Stream Property',
        'Temperature',
        system_units.Temperature,
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.temp.toFixed(2))
      ],
      [
        'Stream Property',
        'pH',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.ph.toFixed(2))
      ],
      [
        'Stream Property',
        'Alkalinity',
        'ppm CaCO3',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.malk.toFixed(2))
      ],
      [
        'Stream Property',
        'Conductivity at 25°C',
        'µS/cm',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return Number(tableValue[d].sat_indices.conductivity).toFixed(flag.length > 0 ? 4 : 1);
        })
      ],
      [
        'Stream Property',
        'Hardness',
        'ppm as CaCO3',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.hardness.toFixed(2))
      ],
      [
        'Stream Property',
        'Density',
        'kg/m3',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.density.toFixed(2))
      ],
      [
        'Stream Property',
        'Ionic Strength',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.ionic_str.toFixed(2))
      ],
      [
        'Stream Property',
        'Osm.Pressure',
        system_units.Pressure,
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.osmotic_pressure.toFixed(2))
      ],
      [
        'Saturation Data',
        'BaSO4',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.baso4)
      ],
      [
        'Saturation Data',
        'CaF2',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.caf2)
      ],
      [
        'Saturation Data',
        'Mg(OH)2',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.mgoh2)
      ],
      [
        'Saturation Data',
        'SiO2',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.sio2)
      ],
      [
        'Saturation Data',
        'SrSO4',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.srso4)
      ],
      [
        'Saturation Data',
        'Struvite',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.struvite)
      ],
      [
        'Saturation Data',
        'LSI',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.lsi)
      ],
      [
        'Saturation Data',
        'SDSI',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.sdi)
      ]
    );
    if (str !== 'stream') {
      arr.push(['']);
      arr.push(['']);
    }
    return arr;
  };
  const createStreamAndDSSROTable = (tableValue, str = 'stream') => {
    const arr = [];
    if (str === 'stream') {
      setCLRO_Stream_data(tableValue, str, arr);
    } else {
      dssro_data.map((ele) => {
        if (str === 'DSSRO Permeate Stream (Loop wise) Summary') {
          return setCLRO_Stream_data(ele.output_user.perm_loop_data, `${ele.output_user.name} Permeate Stream (Loop wise) Summary`, arr);
        }
        return setCLRO_Stream_data(ele.output_user.conc_loop_data, `${ele.output_user.name} Concentrate Stream (Loop wise) Summary`, arr);
      });
    }
    return arr.filter((ele) => ele.length);
  };
  const DSSRO_Permeate_Stream = newData['DSSRO Loop Summary'] && createStreamAndDSSROTable(perm_loop_data, 'DSSRO Permeate Stream (Loop wise) Summary');
  const DSSRO_Concentrate_Stream = newData['DSSRO Loop Summary'] && createStreamAndDSSROTable(conc_loop_data, 'DSSRO Concentrate Stream (Loop wise) Summary');
  const SteamData = newData['Detailed Stream Data'] && createStreamAndDSSROTable(stream_output, 'stream');
  const feed_Preductwaste_Data = newData['Feed-Product-Waste Summary'] && [
    ['Category', 'Parameter', '', ...Object.values(feed_product_waste_summary['Unit ID'])],
    [
      'Information',
      'Water Source',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d].Information)
    ],
    [
      'Ion Concentration',
      'Ca++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Ca++'].toFixed(4))
    ],
    [
      'Ion Concentration',
      'Mg++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Mg++'])
    ],
    [
      'Ion Concentration',
      'Na+',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Na+'])
    ],
    [
      'Ion Concentration',
      'K+',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['K+'])
    ],
    [
      'Ion Concentration',
      'NH4+',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['NH4+'])
    ],
    [
      'Ion Concentration',
      'Ba++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Ba++'])
    ],
    [
      'Ion Concentration',
      'Sr++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Sr++'])
    ],
    [
      'Ion Concentration',
      'Fe++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Fe++'])
    ],
    [
      'Ion Concentration',
      'Mn++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Mn++'])
    ],
    [
      'Ion Concentration',
      'SO4--',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['SO4--'])
    ],
    [
      'Ion Concentration',
      'Cl-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Cl-'])
    ],
    [
      'Ion Concentration',
      'F-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['F-'])
    ],
    [
      'Ion Concentration',
      'NO3-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['NO3-'])
    ],
    [
      'Ion Concentration',
      'Br-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Br-'])
    ],
    [
      'Ion Concentration',
      'PO4---',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['PO4---'])
    ],
    [
      'Ion Concentration',
      'B-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['B-'])
    ],
    [
      'Ion Concentration',
      'SiO2',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].SiO2)
    ],
    [
      'Ion Concentration',
      'H2S',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].H2S)
    ],
    [
      'Ion Concentration',
      'HCO3-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['HCO3-'])
    ],
    [
      'Ion Concentration',
      'CO2',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].CO2)
    ],
    [
      'Ion Concentration',
      'CO3--',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['CO3--'])
    ],
    [
      'Ion Concentration',
      'TDS',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].tds)
    ],
    [
      'Stream Property',
      'Flow',
      system_units['Volume Flow'],
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Flow)
    ],
    [
      'Stream Property',
      'Pressure',
      system_units.Pressure,
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Pressure)
    ],
    [
      'Stream Property',
      'Temperature',
      system_units.Temperature,
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Temperature)
    ],
    [
      'Stream Property',
      'pH',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].pH)
    ],
    [
      'Stream Property',
      'Alkalinity',
      'ppm CaCO3',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Alkalinity)
    ],
    [
      'Stream Property',
      'Conductivity at 25°C',
      'µS/cm',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property']['Conductivity at 25°C'])
    ],
    [
      'Stream Property',
      'Hardness',
      'ppm as CaCO3',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Hardness)
    ],
    [
      'Stream Property',
      'Density',
      'kg/m3',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Density)
    ],
    [
      'Stream Property',
      'Ionic Strength',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property']['Ionic Strength'])
    ],
    [
      'Stream Property',
      'Osm.Pressure',
      system_units.Pressure,
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property']['Osm.Pressure'])
    ],
    [
      'Saturation Data',
      'BaSO4',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].BaSO4)
    ],
    [
      'Saturation Data',
      'CaF2',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].CaF2)
    ],
    [
      'Saturation Data',
      'Mg(OH)2',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data']['Mg(OH)2'])
    ],
    [
      'Saturation Data',
      'SiO2',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].SiO2)
    ],
    [
      'Saturation Data',
      'SrSO4',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].SrSO4)
    ],
    [
      'Saturation Data',
      'Struvite',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].Struvite)
    ],
    [
      'Saturation Data',
      'LSI',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].LSI)
    ],
    [
      'Saturation Data',
      'SDSI',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].SDSI)
    ]
  ];
  const CF_Params = [
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Feed Temperature', KeyText: 'Feed Temperature' },
    { Key: 'Flow Capacity', KeyText: 'Flow Capacity' },
    { Key: 'Filter Type', KeyText: 'Filter Type' },
    { Key: 'Number of Filters', KeyText: 'Number of Filters' },
    { Key: 'Design Flow Per TIE', KeyText: 'Design Flow Per TIE' },
    { Key: 'Actual Flow per TIE', KeyText: 'Actual Flow per TIE' },
    { Key: 'Inlet Pressure', KeyText: 'Inlet Pressure' },
    { Key: 'Outlet Pressure', KeyText: 'Outlet Pressure' },
    { Key: 'Pressure Drop', KeyText: 'Pressure Drop' },
  ];
  const Pumps_Params = [
    { Key: 'RO Unit Attached', KeyText: 'RO/NF Unit Attached' },
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Feed Temperature', KeyText: 'Feed Temperature' },
    { Key: 'Flow Rate', KeyText: 'Flow Rate' },
    { Key: 'Inlet Pressure', KeyText: 'Inlet Pressure' },
    { Key: 'Discharge Pressure', KeyText: 'Discharge Pressure' },
    { Key: 'Power Consumption', KeyText: 'Power Consumption' },
    { Key: 'Combined Efficiency', KeyText: 'Combined Efficiency' },
    { Key: 'Pump Efficiency', KeyText: 'Pump Efficiency' },
    { Key: 'Motor Efficiency', KeyText: 'Motor Efficiency' },
    { Key: 'VFD Efficiency', KeyText: 'VFD Efficiency' },
  ];
  const ERD_key_value = [
    { Key: 'ERD Type', KeyText: 'ERD Type' },
    { Key: 'RO Unit Attached', KeyText: 'RO/NF Unit Attached' },
    { Key: 'Installed Location', KeyText: 'Installed Location' },
    { Key: 'LP Discharge Pressure', KeyText: 'LP Discharge Pressure' },
    { Key: 'Net Transfer Efficiency', KeyText: 'Net Transfer Efficiency' },
    { Key: 'Boost Pressure', KeyText: 'Boost Pressure' },
    {
      Key: 'Leakage (Reject in HP OUT)',
      KeyText: 'Leakage (Reject in HP OUT)',
    },
    { Key: 'Mixing at Membrane Feed', KeyText: 'Mixing at Membrane Feed' },
    { Key: 'Total Power Consumption', KeyText: 'Total Power Consumption' },
    { Key: 'HP Pump', KeyText: 'HP Pump' },
    { Key: 'Circulation Pump', KeyText: 'Circulation Pump' },
    { Key: 'Energy Recovered', KeyText: 'Energy Recovered' },
    { Key: 'Power Saving', KeyText: 'Power Saving' },
  ];
  const Mixer_Splitter_Params = [
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Inlet Stream ID', KeyText: 'Inlet Stream ID' },
    { Key: 'Outlet Stream ID', KeyText: 'Outlet Stream ID' },
    { Key: 'Mode', KeyText: 'Mode' },
    { Key: 'Mix Ratios', KeyText: 'Mix Ratios' },
    { Key: 'Split Ratios', KeyText: 'Split Ratios' },
  ];
  const stripper_values_keys = [
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Feed Temperature', KeyText: 'Feed Temperature' },
    { Key: 'Flow Capacity', KeyText: 'Flow Capacity' },
    { Key: 'Outlet CO2 Concentration', KeyText: 'Outlet CO2 Concentration' },
    { Key: 'Outlet H2S Concentration', KeyText: 'Outlet H2S Concentration' },
    { Key: 'Outlet NH3 Concentration', KeyText: 'Outlet NH3 Concentration' },
  ];
  const chemical_dose_para = [
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Chemical', KeyText: 'Chemical' },
    { Key: 'Supplied Form', KeyText: 'Supplied Form' },
    { Key: 'Dosing Endpoint', KeyText: 'Dosing Endpoint' },
    { Key: 'Target Value', KeyText: 'Target Value' },
    { Key: 'Dosage Rate', KeyText: 'Dosage Rate' },
    { Key: 'Mass Flow Rate', KeyText: 'Mass Flow Rate' },
    { Key: 'Concentration as Metered', KeyText: 'Concentration as Metered' },
    {
      Key: 'Specific Gravity as Metered',
      KeyText: 'Specific Gravity as Metered',
    },
    { Key: 'Metered Flow Rate', KeyText: 'Metered Flow Rate' },
    { Key: 'Avg Cons.As Metered', KeyText: 'Avg Cons.As Metered' },
    { Key: 'Avg Cons.As Supplied', KeyText: 'Avg Cons.As Supplied' },
    {
      Key: 'Avg Cons.As Supplied with SF',
      KeyText: 'Avg Cons.As Supplied with SF',
    },
  ];
  const chemical_dose_supplied_para = [
    { KeyText: 'Chemical Dosing Unit ID', Key: 'Chemical Dosing Unit ID' },
    { KeyText: 'Chemical', Key: 'Chemical' },
    { KeyText: 'Supplied Form', Key: 'Supplied Form' },
    { KeyText: 'Concentration as Supplied', Key: 'Concentration as Supplied' },
    {
      KeyText: 'Specific Gravity as Supplied',
      Key: 'Specific Gravity as Supplied',
    },
    { KeyText: 'Total Consumption', Key: 'Total Consumption' },
    { KeyText: 'Mass Flow Rate', Key: 'Tot.Cons Mass Flow Rate' },
    { KeyText: 'As Supplied', Key: 'Tot.Cons As Supplied' },
    { KeyText: 'As Supplied with SF', Key: 'Tot.Cons As Supplied with SF' },
  ];
  const EDI_Params = [
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Feed Flow', KeyText: 'Feed Flow' },
    { Key: 'Product Flow', KeyText: 'System Product Flow Rate' },
    { Key: 'Concentrate Flow', KeyText: 'Concentrate Flow' },
    { Key: 'Electrode Bleed Flow', KeyText: 'Electrode Bleed Flow' },
    { Key: 'EDI Unit Recovery', KeyText: 'EDI Unit Recovery' },
    { Key: 'Number of E-Cell EDI Stack', KeyText: 'No. of E-Cell EDI Stacks' },
    { Key: 'Feed Temperature', KeyText: 'Feed Temperature' },
    { Key: 'Feed Pressure', KeyText: 'Feed Pressure' },
    { Key: 'Concentrate Pressure', KeyText: 'Concentrate Pressure' },
    { Key: 'Product Outlet Pressure', KeyText: 'Product Outlet Pressure' },
    { Key: 'Current', KeyText: 'Current' },
    { Key: 'Voltage', KeyText: 'Voltage' },
    { Key: 'AC Power', KeyText: 'AC Power' },
    { Key: 'DC Power', KeyText: 'DC Power' },
    { Key: 'Flow Configuration', KeyText: 'Flow Configuration' },
    { Key: 'Feed TDS', KeyText: 'Feed TDS' },
    { Key: 'Feed pH', KeyText: 'Feed pH' },
    { Key: 'Product Resistivity', KeyText: 'Product Resistivity' },
    { Key: 'Product pH', KeyText: 'Product pH' },
    { Key: 'Concentrate TDS', KeyText: 'Concentrate TDS' },
    { Key: 'Concentrate pH', KeyText: 'Concentrate pH' },
    { Key: 'Electrode Bleed TDS', KeyText: 'Electrode Bleed TDS' },
    { Key: 'Electrode Bleed pH', KeyText: 'Electrode Bleed pH' },
  ];
  const EDI_Params1 = [
    {
      key: 'Electrode Gas Generation',
      subkey: [
        {
          key: 'H2',
          keyValue: 'H2',
        },
        {
          key: 'Cl2',
          keyValue: 'Cl2',
        },
        {
          key: '-',
          keyValue: '-',
        },
      ],
    },
    {
      key: 'Blower/Ventilation Sizing for H2',
      subkey: [
        {
          key: 'Explosion limit of H2 in Air',
          keyValue: 'Explosion limit of H2 in Air',
        },
        {
          key: 'Design Safety Factor',
          keyValue: 'Design Safety Factor',
        },
        {
          key: 'Ventilation Blower/Fan',
          keyValue: 'Ventilation Blower/Fan',
        },
        {
          key: 'Size',
          keyValue: 'Size',
        },
      ],
    },
    {
      key: 'Blower/Ventilation Sizing for Cl2',
      subkey: [
        {
          key: 'Explosion limit of Cl2 in Air',
          keyValue: 'Exposure Limit of Cl2 in Air',
        },
        {
          key: 'Design Safety Factor',
          keyValue: 'Design Safety Factor',
        },
        {
          key: 'Ventilation Blower/Fan',
          keyValue: 'Ventilation Blower/Fan',
        },
        {
          key: 'Size',
          keyValue: 'Size',
        },
      ],
    },
  ];
  const RO_units_params = [
    { Key: 'Upstream unit', KeyText: 'Upstream unit' },
    { Key: 'Downstream unit', KeyText: 'Downstream unit' },
    { Key: 'Feed Flow', KeyText: 'Feed Flow' },
    { Key: 'Product Flow', KeyText: 'Permeate Flow' },
    { Key: 'Downstream Flow', KeyText: 'Downstream Permeate Flow' },
    { Key: 'Upstream Flow', KeyText: 'Split Upstream Flow' },
    { Key: 'Concentrate Flow', KeyText: 'Concentrate Flow' },
    { Key: 'RO Unit Recovery', KeyText: 'RO/NF Unit Recovery' },
    { Key: 'Average Flux', KeyText: 'Average Flux' },
    { Key: 'Breakdown by Stage', KeyText: 'Breakdown by Stage' },
    { Key: 'Total Membrane Area', KeyText: 'Total Membrane Area' },
    { Key: 'Feed Temperature', KeyText: 'Feed Temperature' },
    { Key: 'Feed Pressure', KeyText: 'Feed Pressure' },
    { Key: 'Interstage Pressure', KeyText: 'Interstage Pressure' },
    { Key: 'Product Pressure *', KeyText: 'Product Pressure *' },
    { Key: 'Feed TDS', KeyText: 'Feed TDS' },
    { Key: 'Feed pH', KeyText: 'Feed pH' },
    { Key: 'Permeate TDS', KeyText: 'Permeate TDS' },
    { Key: 'Permeate pH', KeyText: 'Permeate pH' },
    { Key: 'Concentrate TDS', KeyText: 'Concentrate TDS' },
    { Key: 'Concentrate pH', KeyText: 'Concentrate pH' },
  ];
  const EDI_Params3 = [
    {
      key: 'Input Parameters',
      subKey: [
        { key: 'Stack Model', keyVal: 'Stack Model' },
        { key: 'Target Resistivity', keyVal: 'Target Resistivity' },
        { key: 'Product Flow', keyVal: 'System Product Flow Rate' },
        { key: 'Flow per stack', keyVal: 'Product Flow Rate per Stack' },
        { key: 'Target Silica guarantee', keyVal: 'Target Silica guarantee' },
        { key: 'Rectifier efficiency', keyVal: 'Rectifier efficiency' },
        { key: 'Rectifier DC output', keyVal: 'Rectifier DC output' },
        { key: 'Feed Pressure', keyVal: 'Feed Pressure' },
        { key: 'Upstream Interconnecting Piping Pressure Loss', keyVal: 'Upstream Interconnecting Piping Pressure Loss' },
        { key: 'Flow Configuration', keyVal: 'Flow Configuration' },
      ],
    },
    {
      key: 'Feedwater Parameters',
      subKey: [
        { key: 'Temperature', keyVal: 'Temperature' },
        { key: 'TEA', keyVal: 'TEA' },
        { key: 'TEC', keyVal: 'TEC' },
        { key: 'pH', keyVal: 'pH' },
        { key: 'Alkalinity', keyVal: 'Alkalinity' },
        { key: 'Hardness', keyVal: 'Hardness' },
        { key: 'Fe++', keyVal: 'Fe++' },
        { key: 'Mn++', keyVal: 'Mn++' },
        { key: 'B', keyVal: 'B' },
        { key: 'H2S', keyVal: 'H2S' },
        { key: 'Silica', keyVal: 'Silica' },
        { key: 'Cond', keyVal: 'Conductvity' },
      ],
    },
    {
      key: 'Calculated Output Parameters',
      subKey: [
        // { key: 'Product Flow Rate', keyVal: 'Product Flow Rate' },
        { key: 'Product Resistivity', keyVal: 'Product Resistivity' },
        {
          key: 'Product Silica guarantee level',
          keyVal: 'Product Silica guarantee level',
        },
        { key: 'Predicted Silica product', keyVal: 'Predicted Product Silica Level' },
        {
          key: 'Product Sodium guarantee level',
          keyVal: 'Predicted Product Sodium level',
        },
        {
          key: 'Product Chloride guarantee level',
          keyVal: 'Predicted Product Chloride level',
        },
        {
          key: 'Product Sulfate guarantee level',
          keyVal: 'Predicted Product Sulfate level',
        },
        {
          key: 'Maximum Allowable Recovery',
          keyVal: 'Maximum Allowable Recovery',
        },
        { key: 'Number of E-Cell EDI Stack', keyVal: 'No. of E-Cell EDI Stacks' },
        { key: 'Current', keyVal: 'Current' },
        { key: 'Voltage', keyVal: 'Voltage' },
        { key: 'E-Factor', keyVal: 'E-Factor' },
        { key: 'DC power', keyVal: 'DC power' },
        { key: 'AC power consumption', keyVal: 'AC power consumption' },
        { key: 'AC energy', keyVal: 'AC energy' },
        // { key: 'Feed pressure', keyVal: 'Feed pressure' },
        {
          key: 'Predicted Product outlet pressure',
          keyVal: 'Predicted Product outlet pressure',
        },
        { key: 'Feed Inlet', keyVal: 'Feed Inlet' },
        { key: 'Concentrate Outlet', keyVal: 'Concentrate Outlet' },
        { key: 'Electrode Bleed', keyVal: 'Electrode Bleed' },
      ],
    },
  ];
  const ROElements_Params = [
    {
      key: 'Flow',
      subKey: [
        { key: 'Feed', keyVal: 'Feed' },
        { key: 'Permeate', keyVal: 'Permeate' }
      ],
    },
    {
      key: 'Pressure',
      subKey: [
        { key: 'Feed', keyVal: 'Feed' },
        { key: 'Net Driving', keyVal: 'Net Driving' },
        { key: 'Delta Pressure', keyVal: 'Delta Pressure' },
        { key: 'Feed Osm. Pressure', keyVal: 'Feed Osm. Pressure' }
      ],
    },
    {
      key: 'Other',
      subKey: [
        { key: 'Recovery', keyVal: 'Recovery' },
        { key: 'Beta (Conc. Pol.)', keyVal: 'Beta (Conc. Pol.)' },
        { key: 'Flux', keyVal: 'Flux' },
        { key: 'A-Value', keyVal: 'A-Value' }
      ],
    }, {
      key: 'Stream Property',
      subKey: [
        { key: 'pH', keyVal: 'pH' },
        { key: 'Alkalinity', keyVal: 'Alkalinity' },
        { key: 'Conductivity at 25°C', keyVal: 'Conductivity at 25°C' },
        { key: 'Hardness', keyVal: 'Hardness' },
        { key: 'Density', keyVal: 'Density' },
        { key: 'Ionic Strength', keyVal: 'Ionic Strength' }
      ],
    }, {
      key: 'Permeate Ion Concentration',
      subKey: [{ 'key': 'Ca++', 'keyVal': 'Ca++', 'unit': 'mg/L' }, { 'key': 'Mg++', 'keyVal': 'Mg++', 'unit': 'mg/L' }, { 'key': 'Na+', 'keyVal': 'Na+', 'unit': 'mg/L' }, { 'key': 'K+', 'keyVal': 'K+', 'unit': 'mg/L' }, { 'key': 'NH4+', 'keyVal': 'NH4+', 'unit': 'mg/L' }, { 'key': 'Ba++', 'keyVal': 'Ba++', 'unit': 'mg/L' }, { 'key': 'Sr++', 'keyVal': 'Sr++', 'unit': 'mg/L' }, { 'key': 'Fe++', 'keyVal': 'Fe++', 'unit': 'mg/L' }, { 'key': 'Mn++', 'keyVal': 'Mn++', 'unit': 'mg/L' }, { 'key': 'SO4--', 'keyVal': 'SO4--', 'unit': 'mg/L' }, { 'key': 'Cl-', 'keyVal': 'Cl-', 'unit': 'mg/L' }, { 'key': 'F-', 'keyVal': 'F-', 'unit': 'mg/L' }, { 'key': 'NO3-', 'keyVal': 'NO3-', 'unit': 'mg/L' }, { 'key': 'Br-', 'keyVal': 'Br-', 'unit': 'mg/L' }, { 'key': 'PO4---', 'keyVal': 'PO4---', 'unit': 'mg/L' }, { 'key': 'B-', 'keyVal': 'B-', 'unit': 'mg/L' }, { 'key': 'SiO2', 'keyVal': 'SiO2', 'unit': 'mg/L' }, { 'key': 'H2S', 'keyVal': 'H2S', 'unit': 'mg/L' }, { 'key': 'HCO3-', 'keyVal': 'HCO3-', 'unit': 'mg/L' }, { 'key': 'CO2', 'keyVal': 'CO2', 'unit': 'mg/L' }, { 'key': 'CO3--', 'keyVal': 'CO3--', 'unit': 'mg/L' }, { 'key': 'TDS', 'keyVal': 'TDS', 'unit': 'mg/L' }],
    }, {
      key: 'Saturation Data',
      subKey: [{ 'key': 'BaSO4', 'keyVal': 'BaSO4', 'unit': '%' }, { 'key': 'CaF2', 'keyVal': 'CaF2 ', 'unit': '%' }, { 'key': 'Mg(OH)2', 'keyVal': 'Mg(OH)2', 'unit': '%' }, { 'key': 'SiO2', 'keyVal': 'SiO2 ', 'unit': '%' }, { 'key': 'SrSO4', 'keyVal': 'SrSO4 ', 'unit': '%' }, { 'key': 'Struvite', 'keyVal': 'Struvite ', 'unit': '%' }, { 'key': 'LSI', 'keyVal': 'LSI', 'unit': '' }, { 'key': 'SDSI', 'keyVal': 'SDSI', 'unit': '' }],
    },
  ];

  const getDocked_summary = (ro_stage_dict, ro_dict) => {
    const tables = {};
    const herder_val = [
      '',
      '',
      '',
      '',
      `Flow (${system_units['Volume Flow']})`,
      `Flow (${system_units['Volume Flow']})`,
      `Flow (${system_units['Volume Flow']})`,
      '', '',
      `Pressure (${system_units.Pressure})`,
      `Pressure (${system_units.Pressure})`,
      'TDS (mg/L)',
      'TDS (mg/L)',
      ''
    ];
    const herder_val1 = [
      'Stage',
      'Housing',
      'Elements',
      'Element Type', 'Feed', 'Conc.', 'Perm.',
      'Recovery (%)',
      `Flux (${system_units.Flux})`, 'Feed', 'dP', 'Feed', 'Perm.',
      'Last Element Beta'
    ];
    // Object.keys(ro_stage_dict).map((v, ind) => {
    if (ro_summary.ro_system_dict['RO/NF Unit ID'] && ro_summary.ro_system_dict['RO/NF Unit ID'].length > 0) {
      ro_summary.ro_system_dict['RO/NF Unit ID'].map((v, ind) => {
        const row = [];
        row.push([
          v,
          '',
          '',
          ' ',
          '',
          '',
          '',
          '',
          '',
          '',
        ]);
        row.push(herder_val);
        row.push(herder_val1);
        Object.values(ro_stage_dict[v].Stage).map((d, i) => {
          const staqge = i + 1;
          row.push([staqge, ...['Housing', 'Elements', 'Element Type', 'Flow', 'Conc.', 'Perm.', '% Recovery', 'Flux', 'Feed Pressure', 'Pressure dp', 'Feed TDS mg/L', 'Perm TDS mg/L', 'Last Elem Beta'].map((k) => {
            if (k === 'Element Type') {
              return ro_dict[v]['grid-data'][i].elementModel;
            }
            if (k === 'Flux' && system_units.Flux === 'm/s') {
              return Number.parseFloat(d[k]).toExponential(2);
            }
            return d[k];
          })]);
        });
        tables[ind] = row;
      });
    }
    return tables;
  };
  const getDetailDesign = (ro_dict) => {
    const herder_val = [
      '',
      '',
      '',
      ' ',
      '',
      `Pressure Change (${system_units.Pressure})`,
      '',
      '',
      '',
      '',
    ];
    let herder_val1 = [
      'Stage',
      'Housing',
      'Elements',
      'Element Type',
      ro_hp.abFactor === 0 ? 'Element Age   (yr) ' : '',
      'Boost',
      'Loss',
      `Permeate P  (${system_units.Pressure})`,
      ro_hp.abFactor === 0 ? 'A-Value ACP' : 'A-Factor',
      ro_hp.abFactor === 0 ? 'B-Value ACP' : 'B-Factor'
    ];
    herder_val1 = herder_val1.filter((ele) => ele);
    const tables = [];
    Object.keys(ro_dict).map((v) => {
      // ro_elem_summary['RO/NF Unit ID'].map((v) => {
      const row = [];
      row.push([v, '', '', ' ', '', '', '', '', '', '']);
      if (ro_dict[v].roMachine && Object.prototype.toString.call(ro_dict[v].roMachine) === '[object Object]') {
        row.push([`RO Machine Configuration - ${ro_dict[v].roMachine.ROMachineModel}`, '', '', ' ', '', '', '', '', '', '']);
      }
      row.push(herder_val);
      row.push(herder_val1);
      ro_dict[v]['grid-data'].map((d) => {
        if (d.pressureVessels !== 0) {
          let arr = ['stage', 'pressureVessels', 'elementsperVessel', 'elementModel', 'interStageBoostPressure', 'interStagePressureLoss', 'permeatePressure', 'fluxAnnual', 'saltPassageAnnual'];
          if (ro_hp.abFactor === 0) {
            arr = ['stage', 'pressureVessels', 'elementsperVessel', 'elementModel', 'elementAge', 'interStageBoostPressure', 'interStagePressureLoss', 'permeatePressure', 'fluxAnnual', 'saltPassageAnnual'];
          }
          row.push(arr.map((k) => d[k]));
        }
      });
      tables.push(row);
    });
    return tables;
  };
  function getROElements(jsonData, ROElements_Params) {
    const csvData = [];
    const heading1 = ['Category', 'Parameter'];
    const heading2 = ['Category', 'Parameter', 'Stage No.'];
    const heading3 = ['Category', 'Parameter', 'Element Pos.'];
    if (jsonData['RO/NF Unit ID'] && jsonData['RO/NF Unit ID'].length > 0) {
      jsonData['RO/NF Unit ID'].forEach(e => {
        Object.keys(jsonData[e]).forEach((d) => {
          const stageNum = Object.keys(jsonData[e][d]);
          stageNum.map((stageEle, ind) => {
            stageNum[ind] = Number(stageEle) + 1;
          });
          heading3.push(...stageNum);
          heading2.push(stageNum);
          heading2.push(d);
          heading1.push(d);
          heading1.push(stageNum);
        });
        heading1.push(e);
      });
    }
    const heading2Array = [].concat(...heading2.map(item =>
      Array.isArray(item) ? new Array(item.length - 1).fill('') : item
    ));
    const heading1Array = [].concat(...heading1.map(item => {
      if (Array.isArray(item)) {
        return new Array(item.length - 1).fill('');
      } if (typeof item === 'string' && item.startsWith('Stage')) {
        if (item === 'Stage 1') {
          return '';
        } return [];
      }
      return item;

    }));
    csvData.push(heading1Array);
    csvData.push(heading2Array);
    csvData.push(heading3);
    ROElements_Params.forEach(param => {
      const category = param.key;
      const subKeys = param.subKey;
      subKeys.forEach(subKey => {
        const row = [];
        row.push(category);
        row.push(subKey.key);
        row.push(jsonData.units[category][subKey.keyVal]);
        if (jsonData['RO/NF Unit ID'] && jsonData['RO/NF Unit ID'].length > 0) {
          jsonData['RO/NF Unit ID'].map((v) => {
            return Object.keys(jsonData[v]).map((d) => {
              return Object.keys(jsonData[v][d]).map((k) => {
                if (subKey.keyVal === 'Flux' && system_units.Flux === 'm/s' && Object.prototype.toString.call(jsonData[v][d][k].Category[category][subKey.keyVal] === '[object Number]')) {
                  return row.push(Number.parseFloat(jsonData[v][d][k].Category[category][subKey.keyVal]).toExponential(2));
                }
                if (Object.prototype.toString.call(jsonData[v][d][k].Category[category][subKey.keyVal] === '[object Number]')) {
                  return row.push(Number(jsonData[v][d][k].Category[category][subKey.keyVal]).toFixed(2));
                }
                return row.push(jsonData[v][d][k].Category[category][subKey.keyVal]);
              });
            });
          });
        }
        csvData.push(row);
      });
    });
    return csvData;
  };
  function jsonToCSV(json) {
    // const keys = Object.keys(json);
    // const headers = Object.keys(json[keys[0]][Object.keys(json[keys[0]])[0]]);
    const csvRows = [];
    clro_elem_summary['CLRO Unit ID'].map((ele) => {
      const clroElements = clro_elem_summary[ele].Elements;
      const keys = Object.keys(clroElements);
      const headers = Object.keys(Object.values(clroElements[keys[0]])[0]);
      // Add headers
      csvRows.push([ele]);
      csvRows.push(['Cycle', 'Element', 'Recovery (%)', `Feed Flow (${system_units['Volume Flow']})`, `Feed Press (${system_units.Pressure})`, 'Feed TDS (mg/L)', `Conc Flow (${system_units['Volume Flow']})`, `Perm Flow (${system_units['Volume Flow']})`, 'Perm TDS (mg/L)']);
      // Add data rows
      keys.forEach(key => {
        const section = clroElements[key];
        const sectionKeys = Object.keys(section);
        sectionKeys.forEach(sectionKey => {
          const row = section[sectionKey];
          const rowValues = headers.map(header => row[header]);
          csvRows.push([key, sectionKey, ...rowValues]);
        });
      });
      csvRows.push(['', '', '', '', '', '', '', '', '']);
      csvRows.push(['', '', '', '', '', '', '', '', '']);
    });
    return csvRows;
  }
  function convertToCSV(jsonData) {
    const csvData = [];
    // const topLevelKeys = Object.keys(jsonData);
    clro_elem_summary['CLRO Unit ID'].map((ele) => {
      const clroElements = clro_elem_summary[ele].Concentrations;
      const topLevelKeys = Object.keys(clroElements);
      const allKeys = new Set();
      const h1 = ['Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)', 'Concentrations (mg/L as ion)'];
      const h2 = ['', '', 'Concentrate', 'Concentrate', 'Concentrate', 'Permeate', 'Permeate', 'Permeate'];
      const h3 = ['', 'Feed', 'Conc CC1', 'Conc CCFinal', 'Conc Total', 'Perm CC1', 'Perm CCFinal', 'Perm Total'];
      csvData.push([ele]);
      csvData.push(h1);
      csvData.push(h2);
      csvData.push(h3);
      // Extract all unique keys from nested objects
      topLevelKeys.forEach(topLevelKey => {
        const nestedObjects = Object.values(clroElements[topLevelKey]);
        nestedObjects.forEach(nestedObject => {
          Object.keys(nestedObject).forEach(key => allKeys.add(key));
        });
      });

      // Create rows for each key
      allKeys.forEach(key => {
        const row = [key];
        topLevelKeys.forEach(topLevelKey => {
          const nestedObjects = Object.values(clroElements[topLevelKey]);
          nestedObjects.forEach(nestedObject => {
            row.push(nestedObject[key] || '0.0');
          });
        });
        csvData.push(row);
      });
      csvData.push(['', '', '', '', '', '', '', '', '']);
      csvData.push(['', '', '', '', '', '', '', '', '']);
    });
    return csvData;
  }
  function JSONToCSVConvertor(jsonData, unitsids, edi_params) {
    try {
      const { design_summary, system_summary } = jsonData;
      const unitIds = Object.values(design_summary[unitsids]);
      const csvData = [['Category', 'Parameter', 'Units', ...unitIds]];
      edi_params.forEach(param => {
        const category = param.key;
        const subKeys = param.subKey;
        subKeys.forEach(subKey => {
          const row = [];
          row.push(category);
          row.push(subKey.keyVal);
          row.push(design_summary.units[category][subKey.key]);
          if (subKey.key === 'Number of E-Cell EDI Stack') {
            row.push(...unitIds.map((v) => appendNumberText2(system_summary[v][subKey.key].toFixed(0))));
          } else {
            row.push(...unitIds.map((v) => {
              if (design_summary[v].Parameter && design_summary[v].Parameter[category] && design_summary[v].Parameter[category][v] && design_summary[v].Parameter[category][v][subKey.key]) {
                return appendNumberText2(design_summary[v].Parameter[category][v][subKey.key]);
              }
              return '-';
            }));
          }
          csvData.push(row);
        });
      });
      return csvData;
    } catch (error) {
      console.log(error);
    }
  };

  function generateTableData(data, parameters, unitsids, headers) {
    const tableData = [];
    let unitIds;
    // Create header row
    if (headers === 'Chemical_dose1') {
      unitIds = Object.values(data[unitsids]);
      const headerRow = ['Chemical Dosing Unit ID', '', ...unitIds];
      tableData.push(headerRow);
    } else if (headers === 'Chemical_dose2') {
      unitIds = Object.keys(data);
      const index = unitIds.indexOf('units');
      unitIds.splice(index, 1);
      const headerRow = ['Chemical Type', '', ...unitIds];
      tableData.push(headerRow);
    } else {
      unitIds = Object.values(data[unitsids]);
      const headerRow = [unitsids, '', ...unitIds];
      tableData.push(headerRow);
    }
    if (headers === 'Mixer-Splitter') {
      parameters.forEach(param => {
        if (param.KeyText === 'Inlet Stream ID' || param.KeyText === 'Outlet Stream ID') {
          const row = [param.KeyText, data.units ? data.units[param.Key] : '-', ...unitIds.map(id => JSON.stringify(data[id][param.Key]).replaceAll('[', '').replaceAll(']', ''))];
          tableData.push(row);
        } else if (param.KeyText === 'Split Ratios' || param.KeyText === 'Mix Ratios') {
          const row = [param.KeyText, data.units ? data.units[param.Key] : '-', ...unitIds.map(id => data[id][param.Key] ? data[id][param.Key].replaceAll('Na', 'NA') : '')];
          tableData.push(row);
        } else {
          const row = [param.KeyText, data.units ? data.units[param.Key] : '-', ...unitIds.map(id => { return appendNumberText(data[id][param.Key]); })];
          tableData.push(row);
        }
      });
    } else if (headers === 'RounitID') {
      parameters.forEach(param => {
        if ((param.KeyText === 'Average Flux' && data.units[param.Key] === 'm/s') || param.KeyText === 'Breakdown by Stage' || param.KeyText === 'Interstage Pressure') {
          const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
            if (param.KeyText === 'Breakdown by Stage' || param.KeyText === 'Interstage Pressure') {
              let split_array = data[id][param.KeyText].split(',').map((unitops) => {
                if (unitops.trim()) {
                  if (data.units[param.Key] === 'm/s')
                    return Number(unitops).toExponential(2);
                  return Number(unitops).toFixed(2);
                }
                return '';
              });
              split_array = split_array.filter((ele) => ele);
              return split_array.join(', ');
            }
            return (data[id][param.Key]);
          })];
          tableData.push(row);
        }
        // added by chandrashekhar when `Downstream Permeate Flow', 'Split Upstream Flow' not exits in paylod (!ro_system_dict.units[keys.key]) check Downstream Permeate Flow exits or not START 8-May-20225
        else if (['Downstream Permeate Flow', 'Split Upstream Flow'].indexOf(param.KeyText) >= 0) {
          if (data.units[param.Key]) {
            const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
              return appendNumberText(data[id][param.Key]);
            })];
            tableData.push(row);
          }
        }
        // added by chandrashekhar when `Downstream Permeate Flow', 'Split Upstream Flow' not exits in paylod (!ro_system_dict.units[keys.key]) check Downstream Permeate Flow exits or not END 8-May-20225
        else {
          const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
            return appendNumberText(data[id][param.Key]);
          })];
          tableData.push(row);
        }
      });
    } else if (headers === 'EDI Ventil summary') {
      parameters.forEach(param => {
        tableData.push([param.key]);
        param.subkey.forEach(subParam => {
          const row = [subParam.keyValue, data.units[param.key][subParam.key], ...unitIds.map(id => {
            return appendNumberText(data[id][param.key][subParam.key]);
          })];
          tableData.push(row);
        });
      });
    } else if (headers === 'Chemical_dose1' || headers === 'Chemical_dose2') {
      parameters.forEach(param => {
        const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
          if (param.Key === 'Metered Flow Rate' || param.Key === 'Avg Cons.As Metered' || param.Key === 'Avg Cons.As Supplied' || param.Key === 'Avg Cons.As Supplied with SF' || param.Key === 'Tot.Cons As Supplied' || param.Key === 'Tot.Cons As Supplied with SF' || param.Key === 'Tot.Cons Mass Flow Rate') {
            return appendNumberText(data[id][param.Key], 4);
          }
          return appendNumberText(data[id][param.Key], 2);
        })];
        tableData.push(row);
      });
      tableData.push(['']);
      // tableData.push(['The Electrode stream must be vented as it contains small quantities of hydrogen, oxygen and possibly chlorine gas (if there is chloride ion in the Electrode stream.) A 2:1 mixture of hydrogen and oxygen gas is produced at a maximum rate of 11.4 ml/amp/minute/stack (dry gas at 25 °C, 1.0 bar), consisting of 7.6 ml of hydrogen and 3.8 ml of oxygen. Ensure ventilation maintains the hydrogen gas levels below 4%.']);
      tableData.push(['The Electrode stream must be vented as it contains small quantities of hydrogen, oxygen and possibly chlorine gas (if there is chloride ion in the Electrode stream.)']);
      tableData.push(['A 2:1 mixture of hydrogen and oxygen gas is produced at a maximum rate of 11.4 ml/amp/minute/stack (dry gas at 25 °C, 1.0 bar), consisting of 7.6 ml of hydrogen and 3.8 ml of oxygen.']);
      tableData.push(['Ensure ventilation maintains the hydrogen gas levels below 4%.']);
    } else {
      parameters.forEach(param => {
        const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
          return appendNumberText(data[id][param.Key]);
        })];
        tableData.push(row);
      });
    }
    // Create data rows
    return tableData;
  };
  const getFlowsheetAllValues = () => {
    const items = Object.keys(stream_output);
    let tempval = true;
    const { temp } = stream_output[items[0]];
    Object.values(stream_output).forEach(ele => {
      if (Number(ele.temp).toFixed(2) !== Number(temp).toFixed(2)) {
        tempval = false;
      }
    });
    const data = [
      ['Stream Id', 'Stream Name', `Flow, ${system_units['Volume Flow']}`, `Temperature, ${system_units.Temperature}`, `Pressure, ${system_units.Pressure}`, 'TDS, mg/l', 'Alkalinity, ppm CaCO3', 'Hardness, ppm as CaCO3', 'pH', 'Conductivity at 25°C, µS/cm']
    ];
    if (tempval) {
      data[0].splice(3, 1);
    }
    items.map((ele) => {
      if (stream_output[ele]) {
        const { sat_indices, prop_dict } = stream_output[ele];
        const allVal = [
          ele,
          stream_output[ele].label ? stream_output[ele].label : '',
          Object.prototype.toString.call(prop_dict.flow) === '[object Number]' ? prop_dict.flow.toFixed(2) : prop_dict.flow,
          Object.prototype.toString.call(prop_dict.temp) === '[object Number]' ? prop_dict.temp.toFixed(2) : prop_dict.temp,
          Object.prototype.toString.call(prop_dict.press) === '[object Number]' ? prop_dict.press.toFixed(2) : prop_dict.press,
          Object.prototype.toString.call(prop_dict.tds) === '[object Number]' ? prop_dict.tds.toFixed(2) : prop_dict.tds,
          Object.prototype.toString.call(prop_dict.malk) === '[object Number]' ? prop_dict.malk.toFixed(2) : prop_dict.malk,
          Object.prototype.toString.call(stream_output[ele].hardness) === '[object Number]' ? stream_output[ele].hardness.toFixed(2) : stream_output[ele].hardness,
          Object.prototype.toString.call(prop_dict.ph) === '[object Number]' ? prop_dict.ph.toFixed(2) : prop_dict.ph,
          Object.prototype.toString.call(sat_indices.conductivity) === '[object Number]' ? sat_indices.conductivity.toFixed(2) : sat_indices.conductivity
        ];
        if (tempval) {
          allVal.splice(3, 1);
        }
        return data.push(allVal);
      }
    });
    return data;
  };
  function CLROjsonToCSV(jsonData) {
    const table = [];

    function addRow(parameter, unit, value) {
      table.push([parameter, unit, value]);
    }
    Object.keys(clro_overview).map((ele) => {
      const clroEle = clro_overview[ele];
      table.push([ele]);
      addRow('Parameters', 'Units', 'Values');
      // DSSRO mode
      addRow('DSSRO mode', '', clroEle['DSSRO mode']);

      // PV
      addRow('Elements per PV', clroEle.units.PV, clroEle.PV['Elements per PV']);
      addRow('Spacers per PV', clroEle.units.PV, clroEle.PV['Spacers per PV']);
      addRow('Length of PV', clroEle.units.PV, clroEle.PV['Length of PV']);

      // Recovery
      addRow('CL Recovery', clroEle.units.Recovery, clroEle.Recovery['CL Recovery'].toFixed(2));
      addRow('BP Recovery', clroEle.units.Recovery, clroEle.Recovery['BP Recovery'].toFixed(2));

      // Flow
      addRow('CL Concentrate Flow', clroEle.units.Flow, clroEle.Flow['CL Concentrate Flow'].toFixed(2));
      addRow('BP Concentrate Flow', clroEle.units.Flow, clroEle.Flow['BP Concentrate Flow'].toFixed(2));
      addRow('CL Net Feed Flow', clroEle.units.Flow, clroEle.Flow['CL Net Feed Flow'].toFixed(2));
      addRow('BP Feed Flow', clroEle.units.Flow, clroEle.Flow['BP Feed Flow'].toFixed(2));
      addRow('CL Permeate Flow', clroEle.units.Flow, clroEle.Flow['CL Permeate Flow'].toFixed(2));

      // Total Circuits
      // addRow('Total Circuits', '', clroEle['Total Circuits']);
      addRow('Total Circuits', '', clroEle.Total['Total Circuits']);
      addRow('# of Turns', '', clroEle.Total['# of Turns']);

      // Duration
      addRow('BP Sequence Duration', clroEle.units.Duration, clroEle.Duration['BP Sequence Duration'].toFixed(2));
      addRow('CL Sequence Duration', clroEle.units.Duration, clroEle.Duration['CL Sequence Duration'].toFixed(2));
      addRow('Complete Cycle Duration', clroEle.units.Duration, clroEle.Duration['Complete Cycle Duration'].toFixed(2));

      // Volume
      addRow('CL System Volume', clroEle.units.Volume, clroEle.Volume['CL System Volume'].toFixed(2));
      addRow('S1 Volume', clroEle.units.Volume, clroEle.Volume['S1 Volume'].toFixed(2));
      addRow('S2 Volume', clroEle.units.Volume, clroEle.Volume['S2 Volume'].toFixed(2));
      addRow('S3 Volume', clroEle.units.Volume, clroEle.Volume['S3 Volume'].toFixed(2));
      addRow('', '', '');
      addRow('', '', '');
    });
    return table;
  };
  const StreamProperty = newData['Flowsheet Design Summary'] && getFlowsheetAllValues();
  const FSDFlowBalance = newData['Flowsheet Design Summary'] && [
    ['Parameter', '', 'Incoming', 'Outgoing'],
    ['', '', '', 'Product', 'Waste'], ['Unit ID (Stream no.)', ...Object.values(coverpage_dict.flow_bal['unit id (stream no.)']).map(e => !Array.isArray(e) ? e : e.join(', '))],
    ['Flow', ...Object.values(coverpage_dict.flow_bal.flow).map((e => !Array.isArray(e) ? e : e.flatMap(v => Number(v).toFixed(2)).join(',')))],
    ['Flow - Total', ...Object.values(coverpage_dict.flow_bal['flow-total']).map((e => Number.isNaN(Number(e)) ? e : Number(e).toFixed(2)))],
    [`Overall Flow Sheet Recovery =  ${localStorage.getItem('systemRecovery') || 'NA'}`]
  ];
  const getAntiscalantData = () => {
    const header = [['Dosed In', 'Antiscalant', 'Dosage in Feed'], ['', '', 'ppm', 'kg/day']];
    Object.keys(argo_summary).forEach((k) => {
      header.push([...['Dosed In', 'Antiscalant', 'Dosage ppm in Feed', 'Dosage kgperday in Feed'].map((p) => appendNumberText(argo_summary[k][p]))]);
    });
    return header;
  };
  const getMembraneSeparator = () => {
    const header1 = [
      ['Unit', 'Unit', '', '', '', '', ''],
      ['Type', 'ID', 'Recovery', 'Feed', 'Product', 'Conc.', 'Electrode Bleed']];
    coverpage_dict.flow_summary.Type.forEach((k) => {
      coverpage_dict.flow_summary.ID[k].map((v) => {
        header1.push([k, v, ...['Recovery', 'Feed', 'Product', 'Waste', 'Electrode'].map((p) => appendNumberText(coverpage_dict.flow_summary[p][v]))]);
      });
    });
    return header1;
  };
  const getErrorData = (errors) => {
    const val = [['Unit Op', 'Type', 'Description']];
    errors.forEach((v) => {
      v.data.forEach((d) => {
        val.push([
          v.name,
          warningMarkerData.some(marker =>
            d.toLowerCase().startsWith(marker.toLowerCase())
          ) ? 'Warning' : 'Error',
          d.split('\n')[0]
        ]);
        // val.push([v.name, d.toLowerCase().indexOf('warning') === 0 ? 'Warning' : 'Error', d.split('\n')[0]]);
      });
    });
    return val;
    // }
  };
  if (newData['Mixer-Splitter Unit Summary']) {
    if (!mixer_summary.units)
      addUnitsInMixerSplitter();
  }
  const MembraneSeparator = newData['Flowsheet Design Summary'] && getMembraneSeparator();

  const StripperData = newData['Stripper Unit Summary'] && generateTableData(stripper_summary, stripper_values_keys, 'Stripper Unit ID');
  const Chemical_DosingData1 = newData['Chemical Dosing Unit Summary'] && generateTableData(chem_dose_summary, chemical_dose_para, 'Chemical Dosing Unit ID', 'Chemical_dose1');
  const Chemical_DosingData2 = newData['Chemical Dosing Unit Summary'] && generateTableData(chem_dose_summary.agg_chem_dose_dict, chemical_dose_supplied_para, 'Chemical Dosing Unit ID', 'Chemical_dose2');
  const ERD_Data = newData['ERD Unit Summary (WIP)'] && generateTableData(erd_summary, ERD_key_value, 'ERD Unit ID');
  const EDI_Data = newData['EDI Unit System-Level Summary'] && generateTableData(edi_summary.system_summary, EDI_Params, 'EDI Unit ID', 'ediDocsummary');
  const RO_unit_Data = newData['RO/NF Unit System-Level Summary'] && generateTableData(ro_summary.ro_system_dict, RO_units_params, 'RO/NF Unit ID', 'RounitID');
  if (newData['EDI Unit System-Level Summary']) {
    edi_summary.ventil_summary['EDI Unit ID'] = edi_summary.system_summary['EDI Unit ID'];
    edi_summary.design_summary['EDI Unit ID'] = edi_summary.system_summary['EDI Unit ID'];
  }
  const EDI_design_summary_Data = newData['EDI Unit System-Level Summary'] && JSONToCSVConvertor({ design_summary: edi_summary.design_summary, system_summary: edi_summary.system_summary }, 'EDI Unit ID', EDI_Params3);
  const EDI_Data1 = newData['EDI Unit System-Level Summary'] && generateTableData(edi_summary.ventil_summary, EDI_Params1, 'EDI Unit ID', 'EDI Ventil summary');
  const CLROOverviewcsvData = newData['DSSRO Section Summary'] && CLROjsonToCSV(clro_overview[clro_elem_summary['CLRO Unit ID'][0]]);
  const csvData = newData['DSSRO Section Summary'] && jsonToCSV(clro_elem_summary[clro_elem_summary['CLRO Unit ID'][0]].Elements);
  const Mixer_Splitter_Data = newData['Mixer-Splitter Unit Summary'] && generateTableData(mixer_summary, Mixer_Splitter_Params, 'Mixer-Splitter Unit ID', 'Mixer-Splitter');
  const CF_Params_Data = newData['CF Unit Summary'] && generateTableData(cf_summary, CF_Params, 'CF Unit ID');
  const Pump_Data = newData['Pump Unit Summary'] && generateTableData(pump_summary, Pumps_Params, 'Pump Unit ID');
  const csvData1 = newData['DSSRO Section Summary'] && convertToCSV(clro_elem_summary[clro_elem_summary['CLRO Unit ID'][0]].Concentrations);
  const RO_elements_Data = newData['Detailed RO/NF Element-Level Data'] && getROElements(ro_elem_summary, ROElements_Params);
  const RO_Design_details = newData['RO/NF Unit System-Level Summary'] && getDetailDesign(ro_hp.ro_dict);
  const RO_DockedSummary = newData['RO/NF Unit Stage-Level Summary'] && getDocked_summary(ro_summary.ro_stage_dict, ro_hp.ro_dict);
  const ARGO_Summary = newData['Antiscalant Dosage Summary'] && getAntiscalantData();
  const ro_details = newData['RO/NF Unit System-Level Summary'] && [RO_unit_Data, ...RO_Design_details];
  const error_data = newData.Notifications && getErrorData(errors);

  const GoogleSheetsData = [
    { label: 'Flowsheet Design Summary', data: { 'StreamProperty': StreamProperty, 'FSDFlowBalance': FSDFlowBalance, 'MembraneSeparator': MembraneSeparator }, 'Flowsheet Design Summary': newData['Flowsheet Design Summary'] },
    { label: 'Feed-Product-Waste Summary', data: feed_Preductwaste_Data, 'Feed-Product-Waste Summary': newData['Feed-Product-Waste Summary'] },
    { label: 'Flowsheet Diagram', data: [['Flowsheet Diagram', ''], []], 'Flowsheet Diagram': true },
    { label: 'RO/NF Unit System-Level Summary', data: { ...ro_details }, 'RO/NF Unit System-Level Summary': newData['RO/NF Unit System-Level Summary'] },
    { label: 'RO/NF Unit Stage-Level Summary', data: RO_DockedSummary, 'RO/NF Unit Stage-Level Summary': newData['RO/NF Unit Stage-Level Summary'] },
    { label: 'DSSRO Section Summary', data: { 'DSSRO Overview': CLROOverviewcsvData, 'DSSRO Flow Summary (Element Level)': csvData, 'DSSRO Stream Composition': csvData1 }, 'DSSRO Section Summary': newData['DSSRO Section Summary'] },
    { label: 'DSSRO Schematic Diagram', data: [['Diagram', ''], []], 'DSSRO Schematic Diagram': newData['DSSRO Section Summary'] },
    { label: 'EDI Unit System-Level Summary', data: { 'Docked Summary': EDI_Data, 'Ventilation Sizing': EDI_Data1, 'EDI Design Parameters': EDI_design_summary_Data }, 'EDI Unit System-Level Summary': newData['EDI Unit System-Level Summary'] },
    { label: 'EDI Schematic Diagram', data: [['Diagram', ''], []], 'EDI Schematic Diagram': newData['EDI Unit System-Level Summary'] },
    { label: 'Chemical Dosing Unit Summary', data: { 'Docked Summary': Chemical_DosingData1, 'Supplied Form': Chemical_DosingData2 }, 'Chemical Dosing Unit Summary': newData['Chemical Dosing Unit Summary'] },
    { label: 'Antiscalant Dosage Summary', data: ARGO_Summary, 'Antiscalant Dosage Summary': newData['Antiscalant Dosage Summary'] },
    { label: 'CF Unit Summary', data: CF_Params_Data, 'CF Unit Summary': newData['CF Unit Summary'] },
    { label: 'ERD Unit Summary (WIP)', data: ERD_Data, 'ERD Unit Summary (WIP)': newData['ERD Unit Summary (WIP)'] },
    { label: 'Pump Unit Summary', data: Pump_Data, 'Pump Unit Summary': newData['Pump Unit Summary'] },
    { label: 'Stripper Unit Summary', data: StripperData, 'Stripper Unit Summary': newData['Stripper Unit Summary'] },
    { label: 'Mixer-Splitter Unit Summary', data: Mixer_Splitter_Data, 'Mixer-Splitter Unit Summary': newData['Mixer-Splitter Unit Summary'] },
    { label: 'Detailed RO/NF Element-Level Data', data: RO_elements_Data, 'Detailed RO/NF Element-Level Data': newData['Detailed RO/NF Element-Level Data'] },
    { label: 'Detailed Stream Data', data: SteamData, 'Detailed Stream Data': newData['Detailed Stream Data'] },
    { label: 'DSSRO Loop Summary', data: { 'DSSRO_Permeate_Stream': DSSRO_Permeate_Stream, 'DSSRO_Concentrate_Stream': DSSRO_Concentrate_Stream }, 'DSSRO Loop Summary': newData['DSSRO Loop Summary'] },
    { label: 'Notifications', data: error_data, 'Notifications': newData.Notifications },
  ];
  return GoogleSheetsData;
};
export default jsontocsvConvertion;
